import { Stack, Table } from "@mantine/core";

import { BillingTabsEnum, getClientBillingTabPath } from "@/billing/constants/billing-tabs";
import { OpenStatementsRow } from "@/billing/types/open-statements";
import AnchorLink from "@/clients/components/AnchorLink";
import { TextWrapper } from "@/components/TextWrapper";
import { formatCurrency } from "@/utils/billing";
import { usDateFormat } from "@/utils/datetime";

import { StatementStatusBadge } from "../../StatementsTab/StatementStatusBadge";

interface OpenStatementsTableRowProps {
  row: OpenStatementsRow;
}

export default function OpenStatementsTableRow({ row }: OpenStatementsTableRowProps) {
  return (
    <Table.Tr data-testid={`open-statements-row-${row.id}`}>
      <Table.Td>
        <Stack gap={0}>
          <AnchorLink
            fw={700}
            c="burgundy.9"
            data-testid={`open-statements-row-open-client-${row.id}`}
            to={getClientBillingTabPath(row.clientId, BillingTabsEnum.STATEMENTS)}
          >
            {row.clientName}
          </AnchorLink>
          <TextWrapper c="gray.6">{row.medicalRecordNumber}</TextWrapper>
        </Stack>
      </Table.Td>
      <Table.Td>
        <TextWrapper>{usDateFormat(row.serviceDate)}</TextWrapper>
      </Table.Td>
      <Table.Td>
        <TextWrapper>{formatCurrency(row.charges)}</TextWrapper>
      </Table.Td>
      <Table.Td>
        <TextWrapper>{row.dueFrom}</TextWrapper>
      </Table.Td>
      <Table.Td style={{ whiteSpace: "nowrap" }}>
        <StatementStatusBadge
          isReadOnly
          status={row.status}
          statementId={row.id}
          onStatusChange={() => {}}
          payer={row.servicePayerCode}
        />
      </Table.Td>
      <Table.Td>
        <TextWrapper>{formatCurrency(row.payments)}</TextWrapper>
      </Table.Td>
      <Table.Td>
        <TextWrapper>{formatCurrency(row.adjustments)}</TextWrapper>
      </Table.Td>
      <Table.Td>
        <TextWrapper>{formatCurrency(row.balance)}</TextWrapper>
      </Table.Td>
    </Table.Tr>
  );
}
